/**
 * Compact horizontal strip of public revision calendars for Home.
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { calendarsApi } from './api';

export default function HomeCalendarsStrip() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    calendarsApi.discover()
      .then((r) => { if (!cancelled) setItems((r.calendars || []).slice(0, 12)); })
      .catch(() => { /* silent — non-critical */ })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  if (loading) return null;
  if (!items.length) return null;

  return (
    <section className="home-cal-strip" aria-label="Shared revision calendars">
      <div className="home-cal-strip-head">
        <div>
          <h2 className="home-cal-strip-title">📅 Shared revision plans</h2>
          <p className="home-cal-strip-sub">Hop on someone else’s schedule — or build your own.</p>
        </div>
        <div className="home-cal-strip-actions">
          <Link to="/calendars" className="secondary-btn">Browse all</Link>
          <Link to="/calendars/new" className="primary-btn">Create plan</Link>
        </div>
      </div>
      <div className="home-cal-strip-track">
        {items.map((c) => (
          <Link key={c.id} to={`/calendars/${c.shareSlug}`} className="home-cal-strip-card">
            <div className="home-cal-strip-emoji" aria-hidden>{c.coverEmoji || '📅'}</div>
            <div className="home-cal-strip-body">
              <div className="home-cal-strip-name">{c.title}</div>
              {c.ownerName && <div className="home-cal-strip-owner">by {c.ownerName}</div>}
              <div className="home-cal-strip-meta">
                <span>{c.dayCount || 0} day{c.dayCount === 1 ? '' : 's'}</span>
                <span>·</span>
                <span>{c.followerCount || 0} follower{c.followerCount === 1 ? '' : 's'}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
